import {useEffect} from 'react';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import {jwtDecode} from 'jwt-decode';
import { useAppDispatch } from 'app/hooks';
import { logout } from 'app/reducer/authSlice';


const Layout = (props:any) => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const token = Cookies.get("token");

    useEffect(() => {
      if(!token){
        navigate("/");
        dispatch(logout());
      }else{
        const decodedToken: any = jwtDecode(token);
        if(decodedToken?.exp * 1000 < Date.now()){
          navigate("/");
          dispatch(logout());
        }
      }
  
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[token,navigate]);    

    return (
        <>
        {props.children}
        </>
    );

}

export default Layout;